import httpClient from '@/lib/httpClient'
import useAuthStore from '@/store/useAuthStore'
import { useQuery } from '@tanstack/react-query'

export default function useGetMoneyPaths() {
  // Keyed by space: money paths belong to one space, and a space without the
  // money-paths feature answers 421 — without the id the previous space's
  // rules stayed in the cache and showed up in the transaction form.
  const teamId = useAuthStore((state) => state.currentTeamId)

  const fetchData = async () => {
    const response = await httpClient.get(`team/money-paths`)
    return [...response.data.data]
  }

  return useQuery({
    queryKey: ['money-paths', 'list', teamId],
    queryFn: fetchData,
    enabled: !!teamId,
  })
}
